export default __webpack_public_path__ + "static/media/Bildschirmfoto 2021-04-19 um 00.03 1.505a2a49.jpg";